<template>
  <div class="wrap">
    <CalendarView
      iclass="input"
      v-model="date"
    />

    <TimePicker
      iclass="input"
      v-model="time"
    />
  </div>
</template>
<script>
import { ref, watch, defineComponent } from 'vue'
import TimePicker from './TimePicker.vue'
import CalendarView from './CalendarView.vue'

export default defineComponent({
  name: 'DateTimePicker',
  components: { TimePicker, CalendarView },
  props: {
    modelValue: {
      type: String,
      default: '' // e.g., '2025-07-04 12:00 AM'
    },
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    // Parse the initial value
    const [initialDate, initialTime] = parseDateTime(props.modelValue)

    const date = ref(initialDate) // 'YYYY-MM-DD'
    const time = ref(initialTime) // 'hh:mm AM/PM'

    function parseDateTime(datetimeStr) {
      const [datePart, ...timeParts] = datetimeStr.split('|')
      const timePart = timeParts.join(' ')
      return [datePart || "", timePart || '']
    }

    // function getToday() {
    //   const today = new Date()
    //   const yyyy = today.getFullYear()
    //   const mm = String(today.getMonth() + 1).padStart(2, '0')
    //   const dd = String(today.getDate()).padStart(2, '0')
    //   return `${yyyy}-${mm}-${dd}`
    // }

    watch([date, time], () => {
      emit('update:modelValue', `${date.value}|${time.value}`)
    }, { immediate: true })

    return {
      date,
      time
    }
  }
})
</script>
<style scoped>
.wrap {
  display: flex;
  gap: 10px;
}
.wrap > *{width:50%}
</style>
